import { useEffect, useState } from 'react';
import {
  RESPONSIBLE_PERIODS,
  getSingleSessionStatus,
  splitSessionHours,
} from '../../utils/responsibleLimits';

function formatSessionPeriodValue(value, t) {
  const { hours, minutes } = splitSessionHours(value);
  if (!hours && !minutes) return '';
  if (!minutes || minutes === '0') return `${hours} ${t('account.responsible.hoursShort')}`;
  if (!hours || hours === '0') return `${minutes} ${t('account.responsible.minutesShort')}`;
  return `${hours} ${t('account.responsible.hoursShort')} ${minutes} ${t('account.responsible.minutesShort')}`;
}

export default function MobileResponsibleSessionCurrent({ limits, t }) {
  const [status, setStatus] = useState(() => getSingleSessionStatus(limits));

  useEffect(() => {
    setStatus(getSingleSessionStatus(limits));
    const id = window.setInterval(() => {
      setStatus(getSingleSessionStatus(limits));
    }, 30000);
    return () => window.clearInterval(id);
  }, [limits]);

  const periodItems = RESPONSIBLE_PERIODS.flatMap((period) => {
    const item = limits?.session?.current?.[period];
    if (!item?.enabled || item.value == null) return [];
    return [{
      key: period,
      label: t(`account.responsible.${period}Limit`),
      value: formatSessionPeriodValue(item.value, t),
    }];
  });

  if (!status && !periodItems.length) {
    return <div className="mobile-responsible-current__empty">{t('account.responsible.limitNotSet')}</div>;
  }

  return (
    <div className="mobile-responsible-session-current form">
      <div className="mobile-responsible-session-current__caption">{t('account.responsible.currentLimits')}</div>
      <div className="mobile-responsible-session-current__container limits-container">
        {status ? (
          <div className="mobile-responsible-session-current__card current-limit">
            <div className="mobile-responsible-session-current__header header">
              <span className="mobile-responsible-session-current__header-label">{t('account.responsible.sessionLimit')}</span>
              <div className="mobile-responsible-session-current__header-value value">
                {status.limit} {t('account.responsible.minutesShort')}
              </div>
            </div>
            <div className="mobile-responsible-session-current__slider-block slider-block">
              <div className="mobile-responsible-session-current__slider-container slider-container">
                <div className="mobile-responsible-session-current__pseudo-slider pseudo-slider">
                  <div className="mobile-responsible-session-current__slider-wrapper wrapper">
                    <div
                      className="mobile-responsible-session-current__slider-progress slider-progress"
                      style={{ width: `${Math.max(0, Math.min(100, status.progress * 100))}%` }}
                    />
                  </div>
                </div>
              </div>
              <div className="mobile-responsible-session-current__slider-meta left">
                <span>{t('account.responsible.timeRemaining')}</span>
                <span className="mobile-responsible-session-current__remaining-value value">
                  {status.remaining} {t('account.responsible.minutesShort')}
                </span>
              </div>
            </div>
          </div>
        ) : null}
        {periodItems.map((item) => (
          <div key={item.key} className="mobile-responsible-session-current__period-row">
            <span className="mobile-responsible-session-current__period-label">{item.label}</span>
            <span className="mobile-responsible-session-current__period-value">{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
